export default __webpack_public_path__ + "static/team2_tablet-9e63fc78a230c3f0ccea1e48205e5783.jpg";